import { Component, OnInit, Input } from "@angular/core";
import { AuthService } from "src/app/core/service/auth.service";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.css"],
})
export class BreadcrumbComponent implements OnInit {
  @Input() title: string;
  @Input() module: string;
  @Input() subModule: string;
  @Input() subModule1: string;
  @Input() moduleLink: string;
  @Input() items: any[];
  @Input() active_item: string;
  @Input() itemLink: string;
  @Input() items1: string;
  moduleId: number;
  subModuleId: number;
  constructor(private authService: AuthService) {
   this.moduleId = parseInt(localStorage.getItem('moduleId'));
   this.subModuleId = parseInt(localStorage.getItem('subModuleId'));
  }

  ngOnInit(): void { }

  subModuleClick() {
    // console.log("jjj")
    this.authService.getMenuList(this.subModuleId, this.moduleId);
  }
  subModuleClick1() {
    // console.log("jjj")
    this.authService.getMenuList(this.subModuleId, this.moduleId);
  }
}
